import { render, staticRenderFns } from "./gasClamp_PLC.vue?vue&type=template&id=2453af96&scoped=true"
import script from "./gasClamp_PLC.vue?vue&type=script&lang=js"
export * from "./gasClamp_PLC.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_PLC.vue?vue&type=style&index=0&id=2453af96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453af96",
  null
  
)

export default component.exports